import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from '../../events.service';

@Component({
  selector: 'app-set-event-zone-status',
  templateUrl: './set-event-zone-status.component.html',
  styleUrls: ['./set-event-zone-status.component.less']
})
export class SetEventZoneStatusComponent implements OnInit {
  @Input() zone: any;
  @Input() eventid: number;
  statuses: any = [];
  model: any = {
    eventId: null,
    zoneId: null,
    statusFrom: '',
    statusTo: '',
    numberOfSeats: 0
  };

  constructor(public activeModal: NgbActiveModal, private service: EventsService) { }

  ngOnInit() {
    this.model.eventId = this.eventid;
    this.model.zoneId = this.zone.id;
    this.load();
  }

  load() {
    this.service.getSeatStatuses()
      .subscribe(statuses => {
        this.statuses = statuses;
      });
  }

  save() {
    this.service.setZoneStatus(this.model)
      .subscribe(success => {
        if (!!success) {
          this.activeModal.close(true);
        }
      });
  }

}
